//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.AMEBaseBuilder.js";
let d=[[[0,"EntryStateName",1,0],[0,"ExitStateName",1,0],[0,"TransitionName",1,0]],[[[],"AddRootConditionOperator",{},0,0],[["parentOperator"],"AddSubConditionOperator",{},1,0],[[],"AddRootConditionOperand",{},0,0],[["parentOperator","siblingOperand"],"AddSubConditionOperand",{R_:{conditionValue:"AME.AMEExtendedObject"}},2,0],[["conditionOperator","operatorType"],"ChangeConditionOperationType",{},2,0],[["conditionItem","isNegation"],"ChangeConditionItemNegation",{},2,0],[["conditionItem"],"AddConditionValue",{},1,0],[["conditionItem","textValue"],"SetConditionValueWithConstantText",{},2,0],[["conditionItem"],"ResetConditionValue",{},1,0],[["conditionItem"],"RemoveConditionItem",{},1,0],[["conditionItem","moveDirection"],"MoveConditionItem",{},2,0]],[]];
SPLM.AME.PlcStateChartTransitionBuilder = class extends SPLM.AME.AMEBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.PlcStateChartTransitionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.PlcStateChartTransitionBuilder.MoveCondition = Object.freeze({
    "Up" : "Up", "Down" : "Down", "Left" : "Left", "Right" : "Right"});

export default SPLM;